import { Injectable } from '@angular/core';
import { EventData } from '@shared/constants/event-bus/event-data';
import { EventKey } from '@shared/constants/event-bus/event-key';
import { filter, map, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventBusService {
  private event$ = new Subject<EventData<unknown>>();

  emit<T = unknown>(eventData: EventData<T>): void {
    this.event$.next(eventData);
  }

  on<T = unknown>(eventKey: EventKey): Observable<T | undefined> {
    return this.event$.pipe(
      filter(
        (eventData): eventData is EventData<T> => eventData.key === eventKey
      ),
      map((eventData: EventData<T>) => eventData.data)
    );
  }
}
